/* eslint-disable array-callback-return */
import { Fragment, useEffect, useState } from "react";
import { FormGroup, Input } from "reactstrap";
import { LI, P, SVG } from "../../AbstractElements";
import { SearchHere } from "../../Constant";
import { H_MENU } from "../../Data/Sidebar/HorizontalMenu";
import { MenuInterface, SubMenuInterface } from "../../Type/HeaderType";
import SearchSuggestionList from "./SearchSuggestionList";

const SearchBox = () => {
  const [open, setOpen] = useState(false);
  const [suggestionOpen, setSuggestionOpen] = useState<boolean>(false);
  const [suggestion, setSuggestion] = useState([]);
  const [searchValue, setSearchValue] = useState<string | undefined>("");

  useEffect(() => {
    const mobileSearch = () => {
      if (window.innerWidth >= 1200) {
        setSuggestionOpen(false);
        document.body.classList.remove("offcanvas");
      }
     else setSearchValue("")
    };
    window.addEventListener("resize", () => mobileSearch());
  }, [suggestionOpen]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchKey = e.target.value.toLowerCase();
    setSearchValue(searchKey);

    if (searchKey !== "") {
      document.body.classList.add("offcanvas");
      let icon: string | undefined;
      let suggestionArray: MenuInterface[] | SubMenuInterface[] | [] | any = [];
      let updatedList: MenuInterface | SubMenuInterface;

      const deepSearchFun = (menuItem: MenuInterface | SubMenuInterface, searchKeyValue: string, mainTitle: string) => {
        if (menuItem.title.toLowerCase().includes(searchKeyValue) && menuItem.url) {
          updatedList = { ...menuItem, mainTitle, icon };
          suggestionArray.push(updatedList);
        }
        if (!menuItem.menu) return;

        menuItem.menu.map((mainSubItem: SubMenuInterface) => {
          if (!mainSubItem.icon) icon = menuItem.icon1;
          deepSearchFun(mainSubItem, searchKeyValue, mainTitle);
        });
      };
      H_MENU.map((mainItem) => {
        mainItem.menu.map((data) => {
          const mainTitle = data.title;
          deepSearchFun(data, searchKey, mainTitle);
        });
      });
      setSuggestion(suggestionArray);
      setSuggestionOpen(true);
    }

    if (searchKey === "") {
      setSuggestionOpen(false);
      setSuggestion([]);
      document.body.classList.remove("offcanvas");
    }
  };

  const handleSearchMenu = () => {
    setOpen(!open);
    setSuggestionOpen(false);
    document.body.classList.remove("offcanvas");
    if (!suggestionOpen) setSearchValue("");
  };

  return (
    <Fragment>
      <LI className="onhover-dropdown serchinput">
        <P className="mb-0 search header-search serchbox" onClick={handleSearchMenu}>
          <SVG iconId="search" />
        </P>
        <FormGroup className={`search-form ${open ? "open" : ""}`} id="resposearch">
          <Input type="text" placeholder={SearchHere} onChange={(e) => handleSearch(e)} value={searchValue} />
        </FormGroup>
      </LI>
      <div className={`Typeahead-menu theme-scrollbar ${suggestionOpen ? "is-open" : ""}`} >
        <SearchSuggestionList setSuggestionOpen={setSuggestionOpen} suggestion={suggestion} setSearchValue={setSearchValue} />
      </div>
    </Fragment>
  );
};

export default SearchBox;
